import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import HomeArticle from './HomeArticle';

function HomeArticles() {
    const [articles, setArticles] = useState([]);
    const [publishedIssues, setPublishedIssues] = useState([]);

    useEffect(() => {
        // Fetch issues first
        fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=getAllIssues')
            .then(res => res.json())
            .then(issueData => {
                if (issueData.success) {
                    const published = issueData.issues.filter(issue => issue.publish === 1);
                    const formattedIssues = published.map(issue => ({
                        value: String(issue.id),
                        date_published: issue.date,
                    }));
                    setPublishedIssues(formattedIssues);

                    // Now fetch articles
                    fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=getAllArticles')
                    .then(res => res.json())
                    .then(articleData => {
                        if (articleData.success) {
                            // Add date_published to each article using issue_id
                            const enrichedArticles = articleData.articles.map(article => {
                                const issue = formattedIssues.find(i => i.value === String(article.issue_id));
                                return {
                                    ...article,
                                    date_published: issue ? issue.date_published : null,
                                };
                            });

                            // Filter articles that are published and have a publish date
                            const filtered = enrichedArticles.filter(
                                a => a.publish === 1 && a.date_published
                            );

                            // Sort by date_published descending
                            const sorted = filtered.sort(
                                (a, b) => new Date(b.date_published) - new Date(a.date_published)
                            );

                            // Take latest 4
                            setArticles(sorted.slice(0, 4));
                        }
                    })
                    .catch(err => console.error('Failed to fetch articles:', err));
                }
            })
            .catch(err => console.error('Failed to fetch issues:', err));
    }, []);

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('en-GB', options).replace(/ /g, '-');
    };

    return (
        <div className='homeiss_section'>
            <div className='homeiss_wrapper'>
                <div className="section_hr"></div>
                <p className='section_title'>Latest Articles</p>

                <div className="homearticles_carousel_wrapper">
                    <div className="homearticles_carousel">
                        {articles.map((article, index) => (
                            <HomeArticle
                                key={index}
                                id={article.id}
                                className="hao_block"
                                title={article.title}
                                date={formatDate(article.date_published)}
                                authors={article.authors}
                            />
                        ))}
                    </div>
                </div>

                <div className='homeiss_all_issues'>
                    <div className='ann_link_wrapper'>
                        <Link to="articles" className='ann_link'>
                            Browse Articles&nbsp;&nbsp;<span className="fa-solid fa-angle-right"></span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomeArticles;